import { memo } from "react";
import styled, { css } from "styled-components";
import size from "../../../helpers/size";
import textSize from "../../../helpers/textSize";
import color, { defaultColor } from "../../../helpers/color";
import transparentize, { transparentizedDefaultColor } from "../../../helpers/transparentize";
const Button = /*#__PURE__*/memo(styled.button.withConfig({
  displayName: "Button",
  componentId: "sc-bhp5u2-0"
})(["", " ", " position:relative;display:inline-flex;align-items:center;justify-content:center;border:none;border-radius:2px;color:", ";cursor:pointer;transition:0.2s ease-in-out;transition-property:background-color,color;outline:none;white-space:nowrap;-webkit-tap-highlight-color:rgba(0,0,0,0);", " &:disabled{opacity:0.4;cursor:default;}", " &:hover:not(:disabled){color:", ";background-color:", ";}"], size, textSize, defaultColor, ({
  active
}) => active && css(["color:", ";"], color), ({
  transparent
}) => transparent ? css(["background-color:transparent;"]) : css(["background-color:", ";"], transparentizedDefaultColor), color, transparentize));
Button.defaultProps = {
  size: "default",
  color: "default",
  textSize: "default"
};
Button.Group = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "Group",
  componentId: "sc-bhp5u2-1"
})(["display:flex;align-items:center;border-radius:2px;background-color:", ";"], color));
Button.Group.defaultProps = {
  color: "divider"
};
export default Button;
//# sourceMappingURL=index.js.map